/* tslint:disable */

import { LogLevel, CacheLocation } from "msal";
import { ILoggerCallback } from "msal/lib-commonjs/Logger";

export class MsalConfig {
  //AuthOptions
  clientId = "";
  authority = "https://login.microsoftonline.com/sgs.onmicrosoft.com";
  validateAuthority?: boolean = true;
  redirectUri?: string;
  postLogoutRedirectUri?: string;
  navigateToLoginRequestUrl? = false;

  //CacheLocation
  cacheLocation: CacheLocation = "localStorage";
  storeAuthStateInCookie?: boolean = false;

  //FrameworkOptions
  isAngular?: boolean = true;
  unprotectedResources?: string[] = [];
  protectedResourceMap?: [string, string[]][] = [];

  //SystemOptions
  loadFrameTimeout? = 6000;
  logger?: ILoggerCallback;
  correlationId? = "1000";
  level?: LogLevel = 2;
  piiLoggingEnabled?: boolean = false;

  popUp?: boolean = false;
  consentScopes?: string[] = [];
}
